import getUrlQueryParams from '../getUrlQueryParams';
import customGroupsService from '../../services/customGroupsService';

export default (state) => {
  const locParam = getUrlQueryParams()?.loc;
  if (!locParam) return [];

  const locationParts = locParam.split('-').filter((location) => location !== '');
  const locations = [];

  locationParts.forEach((locationPart) => {
    // Check if this is a custom group
    const customGroup = customGroupsService.urlUtils.parseUrlParam(locationPart);
    if (customGroup) {
      // Add the custom group to localStorage if it doesn't exist
      // Note: createFromUrl is async, but we'll fire and forget here for backward compatibility
      customGroupsService.createFromUrl(customGroup.id, customGroup.name, customGroup.countries).catch((error) => {
        console.warn('Could not save custom group from URL:', error.message);
      });

      // Add the custom group identifier to locations
      locations.push(locationPart);
      return;
    }

    // Regular country or group - validate it exists
    const isValidLocation = !state.fullListOfCountries || state.fullListOfCountries.find((country) => country.iso === locationPart) || !state.fullListOfCountryGroups || state.fullListOfCountryGroups.find((group) => group.uid === locationPart);

    if (isValidLocation) {
      locations.push(locationPart);
    }
  });

  return locations;
};
